import IsNullOrUndefined from "./ObjectUtils";
import {FeatureType} from "../model/constants";

export const currencyFormatter = new Intl.NumberFormat('de-DE', { // es-ES
    style: 'currency',
    currency: 'EUR',
});

export const getFeaturePriceText = (feature) => {
    if (feature.look_type === FeatureType.Improvement && feature.isPriceDefined === false) {
        return '[Precio por definir]';
    }
    else if (feature.look_type === FeatureType.Default) {
        return '';
    }
    else {
        return currencyFormatter.format(parseFloat(feature.price));
    }
};
export const getPriceText = (price) => {
    return currencyFormatter.format(parseFloat(price));
};
/* export const getPriceText = (price, showPrices) => {
    if (showPrices) {
        return (IsNullOrUndefined(price) || price === '0') ? currencyFormatter.format(0) : currencyFormatter.format(parseFloat(price));
    }

    return (price === null || price === '0') ? 'sin coste' : 'con coste';
}; */
